import { ExportType } from 'constants/exportTypes';

import { Box } from 'shared/mui/Box';
import { ExportTypesButton } from 'shared/mui/Buttons/ExportTypesButton/ExportTypesButton';

type OrdersListActionsProps = {
  exportType: ExportType;
  setExportType: (exportType: ExportType) => void;
  onExportTypesButtonClick: () => void;
};

export const OrdersListActions = ({
  exportType,
  setExportType,
  onExportTypesButtonClick,
}: OrdersListActionsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
      }}
    >
      <ExportTypesButton
        exportType={exportType}
        key="export-button"
        onChangeType={setExportType}
        onClick={onExportTypesButtonClick}
      />
    </Box>
  );
};
